export default "__VITE_ASSET__CYuVLDz$__"